import Subnav from './subnav';

const subnavConfig = {
  name: 'subnav',
  class: Subnav,
  querySelector: {
    controller: '.subnav__toggle-button',
    target: '.subnav__container-content',
  },
};

export default subnavConfig;
